import { Card, CardContent, Grid, useMediaQuery } from '@mui/material';
import Profile from './Profile';
import PaymentMethod from './PaymentMethod';
import Memberships from './Memberships';
import MemberAuthorization from './MemberAuthorization';
import MemberAuthorizationV2 from './MemberAuthorizationV2';
import { useAuth } from "../../providers/AuthProvider";
import { useEffect, useState } from 'react';
import axios from 'axios';
import MemberService from '../../services/MemberService';

function SettingsView({ title }) {

    const { user } = useAuth();
    const userId = user?.id;

    const [ memberships, setMemberships ] = useState([]);
    const [ membershipMafData, setMembershipMafData ] = useState([]);
    const [ hasPendingNMEs, setHasPendingNMEs ] = useState(false);
    const [ isLoadingMemberships, setIsLoadingMemberships ] = useState(false);
    const [ enableMafV2, setEnableMafV2 ] = useState(false);

    const isMobileDevice = useMediaQuery(theme => theme.breakpoints.down('md'));

    useEffect(() => {
        const source = axios.CancelToken.source();

        MemberService.getEnableMafV2(source.token)
            .then(data => setEnableMafV2(data))
            .catch(error => {
                if (!axios.isCancel(error)) {
                    console.error('Error fetching Enable MAFv2 setting:', error);
                }
            });

        return function cleanup() {
            source.cancel();
        }
    }, [])

    useEffect(() => {
        let active = true;
        const source = axios.CancelToken.source();

        if (!userId) {
            setMemberships([]);
            setMembershipMafData([]);
            setHasPendingNMEs(false);
            setIsLoadingMemberships(false);

            return function cleanup() {
                active = false;
                source.cancel();
            };
        }

        setIsLoadingMemberships(true);

        const loadMembershipData = async () => {
            try {
                const [ membershipsList, mafData ] = await Promise.all([
                    MemberService.loadMemberships(userId, source.token),
                    MemberService.loadMembershipMaf(userId, source.token)
                ]);

                if(active) {
                    const nextHasPendingNMEs = membershipsList.length > 0 || Boolean(mafData?.[0]?.nme);

                    setMemberships(membershipsList);
                    setMembershipMafData(mafData || []);
                    setHasPendingNMEs(nextHasPendingNMEs);
                }
            } catch(error) {
                if (!axios.isCancel(error)) {
                    // If no Membership data is found
                    if (error.response?.status === 404) {
                        // Hide payment method section
                        setHasPendingNMEs(false);
                        setMemberships([]);
                        setMembershipMafData([]);
                        console.log("User doesn't have any active memberships or pending NMEs.");
                    } else {
                        console.log("Couldn't load user memberships.");
                    }
                }
            } finally {
                if(active) {
                    setIsLoadingMemberships(false);
                }
            }
        };

        loadMembershipData();
            
        return function cleanup() {
            active = false;
            // Cancels requests (cleanup) on component unmount
            source.cancel();
        }
    }, [userId])

    return (
        <>
            {!isMobileDevice && (
                <header className="app-header">
                    <h2>{title}</h2>
                </header>
            )}
            <Grid container spacing={2} flexDirection="column">
                <Grid item xs={12} md={10} lg={8} xl={6}>
                    <Card>
                        <CardContent>
                            <Memberships memberships={memberships} hasPendingNMEs={hasPendingNMEs} isLoading={isLoadingMemberships} />
                        </CardContent>
                    </Card>
                </Grid>
                {
                    hasPendingNMEs && (
                        <Grid item xs={12} md={10} lg={8} xl={6}>
                            <PaymentMethod />
                        </Grid>
                    )
                }
                <Grid item xs={12} md={10} lg={8} xl={6}>
                    {enableMafV2
                        ? <MemberAuthorizationV2 memberships={membershipMafData} />
                        : <MemberAuthorization memberships={membershipMafData} />}
                </Grid>
                <Grid item xs={12} md={10} lg={8} xl={6}>
                    <Profile />
                </Grid>
            </Grid>
        </>
    )
}

export default SettingsView;